'use client';

import { useSite } from '@/lib/site-context';
import { ExternalLinkIcon } from 'lucide-react';
import Link from 'next/link';
import './SiteSwitcher.scss';

export default function SiteSwitcher() {
  const site = useSite();
  console.log('Current site in SiteSwitcher:', site);

  const otherSite = site.id === 'py' ? 'JS2G' : 'PY2G';
  const otherSiteUrl = site.id === 'py'
    ? (process.env.NEXT_PUBLIC_JS2G_URL || 'https://js2g.com')
    : (process.env.NEXT_PUBLIC_PY2G_URL || 'https://py2g.com');
  
  return (
    <Link target="_blank" href={otherSiteUrl} className="nav-link site-switcher">
      <span className="switcher-text other-site">
        {otherSite}
        <ExternalLinkIcon size={12} style={{ marginLeft: '8px' }} />
      </span>
    </Link>
  );
}
